import React from "react"
import * as styles from "./Menu.module.css"
import { Link } from "gatsby"
import CaretDownDelicate from "../../../../assets/icons/caret-down-delicate.inline.svg"
import DropDown from "../../DropDown/DropDown"
import classNames from "classnames"
import useDeviceType from "../../../../hooks/useDeviceType"
import { HeaderTypes } from "../Header"
import { ItemType, MenuGroup } from "./MenuGroup/MenuGroup"

type MenuProps = {
  title: HeaderTypes
  items: { [key: string]: ItemType[] }
  showOptions: HeaderTypes | undefined
  handleToggleOptions: (type: HeaderTypes) => void
}

const Menu = ({
  title,
  items,
  showOptions,
  handleToggleOptions,
}: MenuProps) => {
  //
  const DeviceType = useDeviceType()

  const columnsHeader = Object.keys(items)

  return (
    <DropDown
      title={
        <a
          className={classNames(styles.title, {
            [styles.active]: showOptions === title,
          })}
          onClick={() => handleToggleOptions(title)}
        >
          {title}
          <CaretDownDelicate />
        </a>
      }
    >
      {columnsHeader.length === 1 ? (
        <div>
          {((DeviceType !== "mobile" && DeviceType !== "tablet") ||
            showOptions === title) && (
            <ul className={styles.container}>
              {items[title].map(i => (
                <Link key={i.name} className={styles.item} to={i.slug}>
                  <li>{i.name}</li>
                </Link>
              ))}
            </ul>
          )}
        </div>
      ) : (
        <div>
          {((DeviceType !== "mobile" && DeviceType !== "tablet") ||
            showOptions === title) && (
            <div className={styles.largMenuContainer}>
              {columnsHeader.map(header => {
                return (
                  <MenuGroup
                    key={header}
                    page={title}
                    name={header}
                    items={items[header]}
                  />
                )
              })}
            </div>
          )}
        </div>
      )}
    </DropDown>
  )
}

export default Menu
